import usePersistentStore from '@gui/store/persistent/persistentStore';
import { LoadingStatus, useLoadingStore } from 'store/LoadingStore';
import { Controller } from './Controller';
import { ControllerManager } from './ControllerManager';

class GridController extends Controller {
    constructor() {
        super();

        usePersistentStore.subscribe(
            (state) => state.layers.layerStates[state.layers.activeLayerID]?.VECTORIAL_SCALAR_MODE,
            () => {
                if (useLoadingStore.getState().loadingStatus !== LoadingStatus.VISUALIZER_READY) return;
                ControllerManager.getInstance().getPipelineController().run();
            }
        );
    }

    protected updateStore(): void {}
}

export default GridController;
